import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Carousel,
    CarouselCaption,
    CarouselControl,
    CarouselIndicators,
    CarouselItem,
} from 'reactstrap';
import _ from 'underscore';
import { LendingSections } from 'app/modules/lending/sections';
import { fetchAdminProducts } from 'app/modules/lending/actions/getAdminProducts';
import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';

class Lending extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            sectionModal: {
                type: null,
                property: '',
                initialItems: [],
                visible: false,
            },
            typeModal: {
                id: null,
                visible: false,
                initialValue: '',
            },
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.page !== prevProps.page) {
            const { page, setting } = this.props,
                page_data = Lending.getOpenPage(page, setting);
            if (page_data.title) document.title = page_data.title;
            this.setState({ activeIndex: 0 });
        }
    }

    static getOpenPage(page, setting) {
        return page === 'primary' || !setting.content.pages[page]
            ? setting.content.primary
            : setting.content.pages[page];
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating) return;
        const { page, setting } = this.props,
            items = Lending.getOpenPage(page, setting).carousel_items;
        const nextIndex =
            this.state.activeIndex ===
            _.size(_.filter(items || [], (i) => !!i.src)) - 1
                ? 0
                : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.animating) return;
        const { page, setting } = this.props,
            items = Lending.getOpenPage(page, setting).carousel_items;
        const nextIndex =
            this.state.activeIndex === 0
                ? _.size(_.filter(items || [], (i) => !!i.src)) - 1
                : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    render() {
        const props = this.props,
            { activeIndex } = this.state,
            { setting, page, user, types, point, getProducts, isMobile } =
                props,
            page_data = Lending.getOpenPage(page, setting),
            carousel_items = _.filter(
                page_data.carousel_items || [],
                (i) => !!i.src
            );
        return (
            <>
                <div>
                    {!carousel_items.length ? null : (
                        <Carousel
                            activeIndex={activeIndex}
                            next={this.next}
                            previous={this.previous}
                        >
                            <CarouselIndicators
                                items={carousel_items}
                                activeIndex={activeIndex}
                                onClickHandler={this.goToIndex}
                            />
                            {carousel_items.map((item, key) => (
                                <CarouselItem
                                    key={key}
                                    onExiting={this.onExiting}
                                    onExited={this.onExited}
                                >
                                    <img
                                        src={
                                            (isMobile && item.src_mobile) ||
                                            item.src
                                        }
                                        alt={item.altText || ''}
                                    />
                                    <CarouselCaption
                                        captionText={item.caption || ''}
                                        captionHeader={item.header || ''}
                                    />
                                </CarouselItem>
                            ))}
                            <CarouselControl
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={this.previous}
                            />
                            <CarouselControl
                                direction="next"
                                directionText="Next"
                                onClickHandler={this.next}
                            />
                        </Carousel>
                    )}
                    <LendingSections
                        isAdmin={user?.isAdmin}
                        types={types?.response?.lists}
                        getProducts={getProducts}
                        point={point?.id}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        point: state.shopState.order.point,
        types: state.shopState.types,
        user: state.authState.user,
        setting: state.appState.setting,
        page: state.lendingState.page,
        title: state.lendingState.title,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProducts: (uuid, valid) =>
            dispatch(fetchAdminProducts({ id: uuid }, valid)),
    };
};

const LendingWrapper = (props) => {
    const isMobile = !useMediaQuery({
        query: breakPoints.mobile,
    });
    return <Lending isMobile={isMobile} {...props} />;
};

export { Lending };

export const LendingLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(LendingWrapper);
